module.exports = __webpack_public_path__ + "static/dsp2025panel-965684fd54b92758059a366db6d01ecf.jpeg";